import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// import { useTranslation } from 'react-i18next';
import './App.css';

// Components
import Navbar from './components/Navbar';
import Footer from './components/Footer';

// Pages
import HomePage from './pages/HomePage';
import ManifestPage from './pages/ManifestPage';
import VotingPage from './pages/VotingPage';
import TargetGroupsPage from './pages/TargetGroupsPage';
import SolutionsPage from './pages/SolutionsPage';
import PartnerPage from './pages/PartnerPage';
import StoryPage from './pages/StoryPage';
import IdeasPage from './pages/IdeasPage';
import WaitlistPage from './pages/WaitlistPage';
import BlogPage from './pages/BlogPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import SeniorsPage from './pages/SeniorsPage';
import CustomerStoryPage from './pages/CustomerStoryPage';
import ImpressumPage from './pages/ImpressumPage';
import DatenschutzPage from './pages/DatenschutzPage';
import ForkButtonDemoPage from './pages/ForkButtonDemoPage';
import ProjectPage from './pages/ProjectPage';

function App() {
  // const [currentLang, setCurrentLang] = useState('de'); // Set default to German
  // const { t, i18n } = useTranslation();

  // Initialize language from browser or localStorage - REMOVED
  // useEffect(() => {
  //   const savedLang = localStorage.getItem('language') || navigator.language?.substring(0, 2) || 'de';
  //   if (savedLang) {
  //     changeLanguage(savedLang);
  //   }
  // }, []);

  // Handle language change with better error handling - REMOVED
  // const changeLanguage = (lang: string) => {
  //   try {
  //     i18n.changeLanguage(lang);
  //     setCurrentLang(lang);
  //     localStorage.setItem('language', lang);
      
  //     // Update HTML lang attribute for accessibility
  //     document.documentElement.setAttribute('lang', lang);
      
  //     // Force component re-render by triggering a small state change
  //     const event = new Event('languageChanged');
  //     window.dispatchEvent(event);
  //   } catch (error) {
  //     console.error('Error changing language:', error);
  //   }
  // };

  useEffect(() => { // Set HTML lang attribute once
    document.documentElement.setAttribute('lang', 'en');
  }, []);

  // Define routes with dynamic names based on current language
  const getRoutes = () => [
    // Start (Home)
    { path: '/', name: 'Home', element: <HomePage />, navSection: 'start' }, // t('nav.home')
    
    // About Us
    { path: '/manifest', name: 'Manifest', element: <ManifestPage />, navSection: 'about-us' }, // t('nav.manifest') navSection: 'von-uns'
    { path: '/about', name: 'About Us', element: <AboutPage />, navSection: 'about-us' }, // path: '/ueber-uns', t('nav.about') navSection: 'von-uns'
    
    // For You
    { path: '/solutions', name: 'Solutions', element: <SolutionsPage />, navSection: 'for-you' }, // path: '/loesungen', t('nav.solutions') navSection: 'fuer-euch'
    { path: '/target-groups', name: 'For You', element: <TargetGroupsPage />, navSection: 'for-you' }, // path: '/fuer-wen', t('nav.targetGroups') navSection: 'fuer-euch'
    { path: '/seniors', name: 'Seniors', element: <SeniorsPage />, navSection: 'for-you' }, // navSection: 'fuer-euch'
    
    // Resources
    { path: '/partners', name: 'Partners', element: <PartnerPage />, navSection: 'resources' }, // path: '/partner-werden', t('nav.partners')
    { path: '/your-story', name: 'Your Story', element: <StoryPage />, navSection: 'resources' }, // path: '/deine-story', t('nav.story')
    { path: '/your-story/restaurant-meier', name: 'Story: Restaurant Meier', element: <CustomerStoryPage />, showInNav: false },
    { path: '/ideas', name: 'Ideas', element: <IdeasPage />, navSection: 'resources' }, // t('nav.ideas')
    { path: '/blog', name: 'Blog', element: <BlogPage />, navSection: 'resources' }, // t('nav.blog')
    { path: '/voting', name: 'Voting', element: <VotingPage />, navSection: 'resources' }, // t('nav.voting')
    
    // Action items (separate section)
    { path: '/waitlist', name: 'Waitlist', element: <WaitlistPage />, navSection: 'actions' }, // t('nav.waitlist')
    { path: '/contact', name: 'Contact', element: <ContactPage />, navSection: 'actions' }, // t('nav.contact')
    
    // Legal pages
    { path: '/imprint', name: 'Imprint', element: <ImpressumPage />, showInNav: false }, // path: '/impressum'
    { path: '/privacy-policy', name: 'Privacy Policy', element: <DatenschutzPage />, showInNav: false }, // path: '/datenschutz'
    
    // Component demos
    { path: '/components/fork-button', name: 'Fork Button', element: <ForkButtonDemoPage />, showInNav: false },
    
    // Project pages
    { path: '/projects/restaurant-template', name: 'Restaurant Template', element: <ProjectPage />, showInNav: false }
  ];

  const routes = getRoutes();
  const navRoutes = routes.filter(route => route.showInNav !== false);

  return (
    <Router>
      <div className="App font-lexend">
        <Navbar currentLang={'en'} routes={navRoutes} setCurrentLang={() => {}} /> {/* Pass 'en' and a dummy function */}
        <Routes>
          {routes.map((route) => (
            <Route key={route.path} path={route.path} element={route.element} />
          ))}
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
